import type { TrpcProxyClient } from '../../trpc';
import type { BlockDraftAsyncDomain } from '@strength/domain';

export const sendTransaction_BlockDraftAsync = async (
  trpc: TrpcProxyClient,
  args: BlockDraftAsyncDomain.Command,
): Promise<{ lastSyncId: number }> => {
  switch (args.type) {
    case 'Publish':
      return trpc.block.publish.mutate(args.input);
    case 'Print':
      return trpc.block.print.mutate(args.input);
    case 'DeletePrintTask':
      return trpc.block.deletePrintTask.mutate(args.input);
    default:
      const _: never = args;
      throw new Error(`Unknown args type: ${(args as any).type}`);
  }
};
